// extracted by mini-css-extract-plugin
export default {"searchBtn":"SearchBtn__searchBtn___VG_TL"};